// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** web页面埋点 POST /web-track/upload-event */
export async function webTrackUploadEventUsingPOST(
  body: API.WebTrackEventReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/web-track/upload-event', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
